/* Arrows for the cart drawer add-ons strip - snippets/cart-upsell.liquid.

   Loaded from the top of snippets/cart-drawer.liquid, NOT from the strip
   itself. The strip usually arrives as HTML injected by the drawer's
   renderContents() after an add, and a <script> injected that way never runs -
   so a definition living inside the strip would simply never exist on a page
   that started with an empty cart. Defined once at page load, the element is
   upgraded automatically every time the drawer swaps in a new copy.

   Touch and trackpads scroll the strip natively; the arrows are for mouse
   users. In RTL the strip's next items lie to the LEFT, so "next" scrolls by a
   negative amount, and scrollLeft is itself negative in RTL - hence the
   absolute values in update(). */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cart-upsell__list');
        this.prev = this.querySelector('[data-dir="prev"]');
        this.next = this.querySelector('[data-dir="next"]');
        if (!this.list || !this.prev || !this.next) return;

        this.rtl = getComputedStyle(this.list).direction === 'rtl';
        this.onScroll = () => this.update();
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);

        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.list);
        this.update();
      }

      disconnectedCallback() {
        if (this.list) this.list.removeEventListener('scroll', this.onScroll);
        if (this.prev) this.prev.removeEventListener('click', this.onPrev);
        if (this.next) this.next.removeEventListener('click', this.onNext);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step(direction) {
        const item = this.list.querySelector('.cart-upsell__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const distance = (item.getBoundingClientRect().width + gap) * direction;
        this.list.scrollBy({ left: this.rtl ? -distance : distance, behavior: 'smooth' });
      }

      update() {
        const max = this.list.scrollWidth - this.list.clientWidth;
        const pos = Math.abs(this.list.scrollLeft);
        const overflowing = max > 2;
        this.toggleAttribute('data-overflowing', overflowing);
        this.prev.disabled = !overflowing || pos <= 2;
        this.next.disabled = !overflowing || pos >= max - 2;
      }
    }
  );
}
